import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { FrequentlyAskedQuestions } from './FrequentlyAskedQuestions';
import { IFrequentlyAskedQuestionsProps } from './FrequentlyAskedQuestionsTypes';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IFrequentlyAskedQuestionsProps = elementAttributesToProps(
    domNode
  );

  return Promise.resolve(<FrequentlyAskedQuestions {...props} />);
};

export default rehydrator;
